// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");

let baseClasses = "text-zinc-700 mt-0 mb-2 last:mb-0 leading-tight";

function Heading__Jsx3(props) {
  let children = props.children;
  let __className = props.className;
  let __as_ = props.as_;
  let as_ = __as_ !== undefined ? __as_ : "h3";
  let className = __className !== undefined ? __className : "";
  if (as_ === "h2") {
    return JsxRuntime.jsx("h2", {
      children: children,
      className: TailwindMerge.twMerge([
        baseClasses,
        "font-light text-[22px] sm:text-[22px] md:text-[26px] lg:text-[32px]",
        className
      ])
    });
  } else if (as_ === "h3") {
    return JsxRuntime.jsx("h3", {
      children: children,
      className: TailwindMerge.twMerge([
        baseClasses,
        "font-light text-[20px] sm:text-[20px] md:text-[24px] lg:text-[26px]",
        className
      ])
    });
  } else if (as_ === "h4") {
    return JsxRuntime.jsx("h4", {
      children: children,
      className: TailwindMerge.twMerge([
        baseClasses,
        "font-medium text-[17px] sm:text-[17px] md:text-[20px] lg:text-[22px]",
        className
      ])
    });
  } else if (as_ === "h5") {
    return JsxRuntime.jsx("h5", {
      children: children,
      className: TailwindMerge.twMerge([
        baseClasses,
        "font-medium text-[16px]",
        className
      ])
    });
  } else if (as_ === "h6") {
    return JsxRuntime.jsx("h6", {
      children: children,
      className: TailwindMerge.twMerge([
        baseClasses,
        "font-medium text-[14px]",
        className
      ])
    });
  } else {
    return JsxRuntime.jsx("h1", {
      children: children,
      className: TailwindMerge.twMerge([
        baseClasses,
        "font-light text-[22px] sm:text-[22px] md:text-[26px] lg:text-[42px]",
        className
      ])
    });
  }
}

let make = Heading__Jsx3;

exports.baseClasses = baseClasses;
exports.make = make;
/* tailwind-merge Not a pure module */
